import { render, staticRenderFns } from "./SingleBarChart.vue?vue&type=template&id=01b32c62&scoped=true"
import script from "./SingleBarChart.vue?vue&type=script&lang=ts"
export * from "./SingleBarChart.vue?vue&type=script&lang=ts"
import style0 from "./SingleBarChart.vue?vue&type=style&index=0&id=01b32c62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b32c62",
  null
  
)

export default component.exports